var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webphone-contacts" }, [
    _c("div", { staticClass: "contacts-header" }, [
      _c("h4", [_vm._v("Dahililer")]),
      _vm._v(" "),
      _vm.extensions.length > 0
        ? _c(
            "button",
            { staticClass: "refresh-btn", on: { click: _vm.refreshContacts } },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("refresh")])]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.extensions.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "empty-text" }, [
            _vm._v("Dahili listesi yüklenemedi"),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "retry-btn", on: { click: _vm.refreshContacts } },
            [_vm._v("Yeniden Dene")]
          ),
        ])
      : _c("div", { staticClass: "contacts-list" }, [
          _c("div", { staticClass: "search-box" }, [
            _c("i", { staticClass: "material-icons search-icon" }, [
              _vm._v("search"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchQuery,
                  expression: "searchQuery",
                },
              ],
              staticClass: "search-input",
              attrs: { placeholder: "Kişi ara..." },
              domProps: { value: _vm.searchQuery },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchQuery = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.searchQuery
              ? _c(
                  "button",
                  {
                    staticClass: "clear-search-btn",
                    on: {
                      click: function ($event) {
                        _vm.searchQuery = ""
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-sections" }, [
            _vm.recentContacts.length > 0
              ? _c(
                  "div",
                  { staticClass: "contact-section" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.recentContacts, function (contact) {
                      return _c(
                        "div",
                        {
                          key: "recent-" + contact.number,
                          staticClass: "contact-item",
                          class: { disabled: !_vm.canMakeCall(contact) },
                          on: {
                            click: function ($event) {
                              return _vm.handleContactClick(contact)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "contact-avatar-wrapper" },
                            [
                              contact.userId
                                ? _c("AgentAvatar", {
                                    attrs: {
                                      userID: contact.userId,
                                      size: 40,
                                      isNamed: false,
                                    },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass: "default-avatar",
                                      style: {
                                        backgroundColor: _vm.getAvatarColor(
                                          contact.name
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.getInitials(contact.name))
                                        ),
                                      ]),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "status-indicator",
                                class: contact.status,
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "contact-info" }, [
                            _c("div", { staticClass: "contact-name" }, [
                              _vm._v(_vm._s(contact.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "contact-number" }, [
                              _vm._v(_vm._s(contact.extension)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "contact-status" }, [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons status-icon",
                                  class: contact.status,
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        contact.status === "online"
                                          ? "phone"
                                          : "phone_disabled"
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getStatusText(contact.status))
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "contact-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "action-btn call-btn",
                                attrs: { disabled: !_vm.canMakeCall(contact) },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleCall(contact)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("call"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "contact-section" }, [
              _c("div", { staticClass: "section-header" }, [
                _c("h5", [_vm._v("Tüm Kişiler")]),
                _vm._v(" "),
                _c("span", { staticClass: "contact-count" }, [
                  _vm._v(_vm._s(_vm.filteredContacts.length)),
                ]),
              ]),
              _vm._v(" "),
              _vm.filteredContacts.length === 0
                ? _c("div", { staticClass: "no-results" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("search_off"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Arama sonucu bulunamadı")]),
                  ])
                : _c(
                    "div",
                    { staticClass: "contacts-grid" },
                    _vm._l(_vm.filteredContacts, function (contact) {
                      return _c(
                        "div",
                        {
                          key: contact.number,
                          staticClass: "contact-item",
                          class: { disabled: !_vm.canMakeCall(contact) },
                          on: {
                            click: function ($event) {
                              return _vm.handleContactClick(contact)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "contact-avatar-wrapper" },
                            [
                              contact.userId
                                ? _c("AgentAvatar", {
                                    attrs: {
                                      userID: contact.userId,
                                      size: 40,
                                      isNamed: false,
                                    },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass: "default-avatar",
                                      style: {
                                        backgroundColor: _vm.getAvatarColor(
                                          contact.name
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.getInitials(contact.name))
                                        ),
                                      ]),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "status-indicator",
                                class: contact.status,
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "contact-info" }, [
                            _c("div", { staticClass: "contact-name" }, [
                              _vm._v(_vm._s(contact.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "contact-number" }, [
                              _vm._v(_vm._s(contact.extension)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "contact-status" }, [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons status-icon",
                                  class: contact.status,
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        contact.status === "online"
                                          ? "phone"
                                          : "phone_disabled"
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getStatusText(contact.status))
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "contact-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "action-btn info-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showContactInfo(contact)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("info"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "action-btn call-btn",
                                attrs: { disabled: !_vm.canMakeCall(contact) },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleCall(contact)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("call"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
            ]),
          ]),
        ]),
    _vm._v(" "),
    _vm.selectedContact
      ? _c(
          "div",
          {
            staticClass: "contact-info-modal",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.selectedContact = null
              },
            },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass: "contact-avatar-large",
                    style: {
                      backgroundColor: _vm.getAvatarColor(
                        _vm.selectedContact.name
                      ),
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getInitials(_vm.selectedContact.name))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contact-title" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.selectedContact.name))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.selectedContact.number))]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: {
                      click: function ($event) {
                        _vm.selectedContact = null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Dahili Numarası:"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedContact.extension)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.selectedContact.email
                  ? _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("E-posta:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedContact.email)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedContact.department
                  ? _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Departman:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedContact.department)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedContact.title
                  ? _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("Ünvan:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedContact.title)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Durum:")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "value status",
                      class: _vm.selectedContact.status,
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.getStatusText(_vm.selectedContact.status)
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "cancel-btn",
                    on: {
                      click: function ($event) {
                        _vm.selectedContact = null
                      },
                    },
                  },
                  [_vm._v("Kapat")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "call-btn", on: { click: _vm.callFromModal } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call"),
                    ]),
                    _vm._v("\n                    Ara\n                "),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h5", [_vm._v("Son Arananlar")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }